export default {"src":"/_next/static/media/msu-logo-h.7f65b178.svg","height":177,"width":417,"blurWidth":0,"blurHeight":0};